import React from "react";
import SlideOverPanel from "@/src/shared/components/SlideOverPanel";
import RailContent from "./RailContent";
import { homepageService, type TRailMatch } from "../services";

interface IRailDrawerProps {
  match: TRailMatch | null;
  onClose: () => void;
}

/** A rail's page on mobile, as the app pushes its screen: a panel from the right. */
const RailDrawer: React.FC<IRailDrawerProps> = ({ match, onClose }) => {
  const details = match ? homepageService.matchDetails(match) : null;
  return (
    <SlideOverPanel
      isOpen={match !== null}
      title={details?.title ?? ""}
      subtitle={details?.subtitle}
      onClose={onClose}
    >
      {(scroller) =>
        match && <RailContent match={match} scrollRoot={scroller} />
      }
    </SlideOverPanel>
  );
};

export default RailDrawer;
